// Security Framework PDF Generator - Socle de S\u00e9curit\u00e9 Report (bilingue FR/EN)
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const STRINGS = {
    fr: {
        metaTitle: 'Rapport Atelier 1 - Socle de S\u00e9curit\u00e9',
        metaSubject: 'EBIOS RM - Atelier 1 - Socle de S\u00e9curit\u00e9',
        metaAuthor: 'Syst\u00e8me EBIOS RM',
        metaCreator: 'EBIOS RM Security Framework Report Generator',
        metaKeywords: 'EBIOS RM, Atelier 1, Socle de S\u00e9curit\u00e9, Security Framework, S\u00e9curit\u00e9, Risques',
        defaultAnalysisName: 'Analyse EBIOS RM',
        defaultOrg: 'Organisation',
        reference: 'EBIOSRM_ATELIER1_SOCLE',
        locale: 'fr-FR',
        status: 'Finalis\u00e9',
        reportType: 'Atelier 1 - Socle de S\u00e9curit\u00e9',
        statusLabels: {
            4: 'Conforme',
            3: 'Partiellement conforme',
            2: 'Non conforme',
            1: 'Non applicable',
            0: '\u00c0 \u00e9valuer',
            // Legacy mappings for backward compatibility
            'applied': 'Conforme',
            'partially-applied': 'Partiellement conforme',
            'not-applied': 'Non conforme'
        },
        programLabel: 'Programme :',
        programValue: 'Analyse des risques \u2013 EBIOS RM',
        internal: 'Interne',
        documentLabel: 'Document :',
        docTypeValue: 'Rapport Atelier 1 - Socle de S\u00e9curit\u00e9',
        versionLabel: 'Version :',
        refLabel: 'R\u00e9f :',
        reportHeading: 'Rapport d\'Analyse de Risques:',
        ebiosTitle: 'EBIOS RM - Atelier 1',
        coverSubtitle: 'Socle de S\u00e9curit\u00e9',
        infoProgramLabel: 'Programme',
        infoProgramValue: 'Atelier 1 - P\u00e9rim\u00e8tre et socle de s\u00e9curit\u00e9',
        infoOrgLabel: 'Organisation',
        notSpecified: 'Non sp\u00e9cifi\u00e9',
        classificationLabel: 'Classification',
        revisionFreqLabel: 'Fr\u00e9quence de r\u00e9vision',
        revisionFreqValue: 'Annuelle / chaque changement majeur',
        statusLabel: 'Statut',
        statusValue: 'Compl\u00e9t\u00e9',
        rulesCountLabel: 'R\u00e8gles de s\u00e9curit\u00e9',
        selectedRulesCount: (n) => `${n || 0} s\u00e9lectionn\u00e9es`,
        genDateLabel: 'Date de g\u00e9n\u00e9ration',
        historyHeaders: ['Version', 'Date', 'Description, remarques', 'Auteur', 'V\u00e9rificateur', 'Approbateur'],
        initialEntry: 'Rapport initial Socle de S\u00e9curit\u00e9 - Atelier 1',
        footerMethodo: 'M\u00e9thodologie EBIOS RM - Atelier 1: Socle de S\u00e9curit\u00e9',
        footerConfidential: 'Document confidentiel - Usage interne uniquement',
        watermarkDefault: 'ebiosens - rapport confidentiel',
        pageHeader: 'Rapport Atelier 1 - Socle de S\u00e9curit\u00e9',
        sectionOverview: 'Vue d\'ensemble',
        sectionDetails: 'D\u00e9tails par r\u00e8gle',
        pageFooterLeft: 'Rapport EBIOS RM',
        pageFooterCenter: 'Confidentiel - Usage interne',
        overviewTitle: '1. VUE D\'ENSEMBLE DU SOCLE DE S\u00c9CURIT\u00c9',
        introText: (n) => `Ce document pr\u00e9sente le socle de s\u00e9curit\u00e9 d\u00e9fini durant l'Atelier 1 de la ` +
            `m\u00e9thodologie EBIOS Risk Manager. ${n} r\u00e8gle${n > 1 ? 's' : ''} de s\u00e9curit\u00e9 ${n > 1 ? 'ont' : 'a'} \u00e9t\u00e9 s\u00e9lectionn\u00e9e${n > 1 ? 's' : ''}.`,
        distByFramework: '1.1. Distribution par R\u00e9f\u00e9rentiel',
        distByStatus: '1.2. Distribution par Statut',
        ruleCountLine: (count, percentage) => `${count} r\u00e8gle${count > 1 ? 's' : ''} (${percentage}%)`,
        rulesSectionTitle: '3. R\u00e8gles de S\u00e9curit\u00e9',
        nonIntentionalRisk: 'Risque non intentionnel',
        fearedEvent: '\u00c9v\u00e9nement redout\u00e9',
        commentPrefix: 'Commentaire : ',
        unnamedRule: 'Sans nom',
        tableHead: ['#', 'R\u00e8gle', 'Description', 'Statut', 'Commentaire sur l\'\u00e9cart', 'Justification'],
        defaultSaveName: 'socle-de-securite.pdf'
    },
    en: {
        metaTitle: 'Workshop 1 Report - Security Baseline',
        metaSubject: 'EBIOS RM - Workshop 1 - Security Baseline',
        metaAuthor: 'EBIOS RM System',
        metaCreator: 'EBIOS RM Security Framework Report Generator',
        metaKeywords: 'EBIOS RM, Workshop 1, Security Baseline, Security Framework, Risks',
        defaultAnalysisName: 'EBIOS RM Analysis',
        defaultOrg: 'Organization',
        reference: 'EBIOSRM_WORKSHOP1_BASELINE',
        locale: 'en-GB',
        status: 'Finalized',
        reportType: 'Workshop 1 - Security Baseline',
        statusLabels: {
            4: 'Complete',
            3: 'Minor Gaps',
            2: 'Major Gaps',
            1: 'Not Effective',
            0: 'N/A',
            // Legacy mappings for backward compatibility
            'applied': 'Complete',
            'partially-applied': 'Minor Gaps',
            'not-applied': 'Not Effective'
        },
        programLabel: 'Program:',
        programValue: 'Risk Analysis \u2013 EBIOS RM',
        internal: 'Internal',
        documentLabel: 'Document:',
        docTypeValue: 'Workshop 1 Report - Security Baseline',
        versionLabel: 'Version:',
        refLabel: 'Ref:',
        reportHeading: 'Risk Analysis Report:',
        ebiosTitle: 'EBIOS RM - Workshop 1',
        coverSubtitle: 'Security Baseline',
        infoProgramLabel: 'Program',
        infoProgramValue: 'Workshop 1 - Scope and Security Baseline',
        infoOrgLabel: 'Organization',
        notSpecified: 'Not specified',
        classificationLabel: 'Classification',
        revisionFreqLabel: 'Revision Frequency',
        revisionFreqValue: 'Annual / Every major change',
        statusLabel: 'Status',
        statusValue: 'Completed',
        rulesCountLabel: 'Security Rules',
        selectedRulesCount: (n) => `${n || 0} selected`,
        genDateLabel: 'Generation Date',
        historyHeaders: ['Version', 'Date', 'Description, notes', 'Author', 'Reviewer', 'Approver'],
        initialEntry: 'Initial Security Baseline Report - Workshop 1',
        footerMethodo: 'EBIOS RM Methodology - Workshop 1: Security Baseline',
        footerConfidential: 'Confidential Document - Internal Use Only',
        watermarkDefault: 'ebiosens - confidential report',
        pageHeader: 'Workshop 1 Report - Security Baseline',
        sectionOverview: 'Overview',
        sectionDetails: 'Rule Details',
        pageFooterLeft: 'EBIOS RM Report',
        pageFooterCenter: 'Confidential - Internal Use',
        overviewTitle: '1. SECURITY BASELINE OVERVIEW',
        introText: (n) => `This document presents the security baseline defined during Workshop 1 of the ` +
            `EBIOS Risk Manager methodology. ${n} security rule${n !== 1 ? 's have' : ' has'} been selected.`,
        distByFramework: '1.1. Distribution by Framework',
        distByStatus: '1.2. Distribution by Status',
        ruleCountLine: (count, percentage) => `${count} rule${count !== 1 ? 's' : ''} (${percentage}%)`,
        rulesSectionTitle: '3. Security Rules',
        nonIntentionalRisk: 'Non-intentional risk',
        fearedEvent: 'Feared event',
        commentPrefix: 'Comment : ',
        unnamedRule: 'Unnamed',
        tableHead: ['#', 'Rule', 'Description', 'Status', 'Gap Comment', 'Justification'],
        defaultSaveName: 'security-baseline.pdf'
    }
};

class SecurityFrameworkPdfGenerator {
    constructor(securityFrameworkData = {}, analysisData = {}, dreadedEventsData = [], businessValuesData = [], lang = 'fr') {
        this.securityFrameworkData = securityFrameworkData || {};
        this.analysisData = analysisData || {};
        this.dreadedEventsData = dreadedEventsData || [];
        this.businessValuesData = businessValuesData || [];
        this.lang = lang;
        this.T = STRINGS[lang] || STRINGS.fr;

        // Initialize simple jsPDF instance
        this.pdf = new jsPDF('p', 'mm', 'a4');

        // Set PDF metadata
        this.pdf.setProperties({
            title: this.T.metaTitle,
            subject: this.T.metaSubject,
            author: this.T.metaAuthor,
            creator: this.T.metaCreator,
            keywords: this.T.metaKeywords
        });

        // Set analysis metadata for cover page
        this.metadata = {
            analysisId: this.analysisData.id || 'N/A',
            analysisName: this.analysisData.name || this.analysisData.analysisName || this.T.defaultAnalysisName,
            companyName: this.analysisData.companyName || this.analysisData.organizationName || this.T.defaultOrg,
            version: '1.0',
            reference: this.T.reference,
            createdBy: '',
            lastModified: new Date().toLocaleDateString(this.T.locale),
            status: this.T.status,
            reportType: this.T.reportType,
            rulesCount: this.countTotalRules()
        };

        // Status labels and colors (5-level system)
        // 4: Conforme, 3: Partiellement conforme, 2: Non conforme, 1: Non applicable, 0: À évaluer
        this.statusLabels = { ...this.T.statusLabels };

        this.statusColors = {
            4: [34, 197, 94],      // Green - Conforme
            3: [251, 191, 36],     // Yellow - Partiellement conforme
            2: [249, 115, 22],     // Orange - Non conforme
            1: [239, 68, 68],      // Red - Non applicable
            0: [156, 163, 175],    // Gray - À évaluer
            // Legacy mappings for backward compatibility
            'applied': [34, 197, 94],
            'partially-applied': [251, 191, 36],
            'not-applied': [239, 68, 68]
        };

        // Framework type colors
        this.frameworkColors = {
            'cis': [59, 130, 246],      // Blue
            'nist': [16, 185, 129],     // Green
            'iso27002': [245, 158, 11], // Yellow
            'anssi': [239, 68, 68],     // Red
            'custom': [107, 114, 128]   // Gray
        };
    }

    /**
     * Count total rules across all frameworks
     */
    countTotalRules() {
        const selectedRules = this.securityFrameworkData.selectedRules || {};
        let total = 0;
        Object.values(selectedRules).forEach(rules => {
            if (Array.isArray(rules)) {
                total += rules.length;
            }
        });
        return total;
    }

    /**
     * Generate Security Framework Cover Page
     */
    generateCoverPage() {
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();

        // Clean white background
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(0, 0, pageWidth, pageHeight, 'F');

        // Header table - Programme info
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.setDrawColor(0, 0, 0);
        this.pdf.setLineWidth(0.5);
        this.pdf.rect(15, 15, 180, 10, 'S');

        this.pdf.setFontSize(9);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.programLabel, 17, 21);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.programValue, 45, 21);

        // Internal classification label
        this.pdf.setFillColor(200, 200, 200);
        this.pdf.rect(135, 15, 60, 10, 'FD');
        this.pdf.setTextColor(0, 0, 0);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.internal, 155, 21);
        this.pdf.setTextColor(0, 0, 0);

        // Document type
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(15, 25, 180, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.documentLabel, 17, 30);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.docTypeValue, 45, 30);

        // Version and Reference
        this.pdf.rect(15, 33, 90, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.versionLabel, 17, 38);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.metadata.version || '1.0', 37, 38);

        this.pdf.rect(105, 33, 90, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.refLabel, 107, 38);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.metadata.reference || this.T.reference, 120, 38);

        // Main title
        this.pdf.setFontSize(18);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.setTextColor(37, 99, 235);
        this.pdf.text(this.T.reportHeading, 105, 65, { align: 'center' });

        this.pdf.setFontSize(18);
        const maxTW = this.pdf.internal.pageSize.getWidth() - 30;
        const companyName = `${this.metadata.companyName}`;
        const al = this.pdf.splitTextToSize(companyName, maxTW);
        al.forEach((line, i) => this.pdf.text(line, 105, 80 + i * 7, { align: 'center' }));
        const extraY = (al.length - 1) * 7;

        // EBIOS RM title
        this.pdf.setFontSize(24);
        this.pdf.setTextColor(37, 99, 235);
        this.pdf.text(this.T.ebiosTitle, 105, 110 + extraY, { align: 'center' });

        // Security Framework section
        this.pdf.setFontSize(16);
        this.pdf.setTextColor(59, 130, 246); // Blue for security framework
        this.pdf.text(this.T.coverSubtitle, 105, 135 + extraY, { align: 'center' });
        this.pdf.setTextColor(0, 0, 0);

        // Information table
        const tableStartY = 150 + extraY;
        const rowHeight = 8;

        const tableData = [
            [this.T.infoProgramLabel, this.T.infoProgramValue],
            [this.T.infoOrgLabel, this.metadata.companyName || this.T.notSpecified],
            [this.T.classificationLabel, this.T.internal],
            [this.T.revisionFreqLabel, this.T.revisionFreqValue],
            [this.T.statusLabel, this.T.statusValue],
            [this.T.rulesCountLabel, this.T.selectedRulesCount(this.metadata.rulesCount)],
            [this.T.genDateLabel, new Date().toLocaleDateString(this.T.locale)]
        ];

        tableData.forEach((row, index) => {
            const y = tableStartY + (index * rowHeight);

            // Label column (blue background)
            this.pdf.setFillColor(41, 82, 163);
            this.pdf.rect(15, y, 65, rowHeight, 'FD');
            this.pdf.setTextColor(255, 255, 255);
            this.pdf.setFontSize(9);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text(row[0], 17, y + 5.5);

            // Value column (light gray background)
            this.pdf.setFillColor(235, 235, 235);
            this.pdf.rect(80, y, 115, rowHeight, 'FD');
            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFont('helvetica', 'normal');

            // Handle long text
            const maxWidth = 110;
            const lines = this.pdf.splitTextToSize(row[1], maxWidth);
            if (lines.length > 1) {
                const truncated = row[1].length > 50 ? row[1].substring(0, 47) + '...' : row[1];
                this.pdf.text(truncated, 82, y + 5.5);
            } else {
                this.pdf.text(row[1], 82, y + 5.5);
            }
        });

        // Version history table
        const historyY = 215;
        const headerHeight = 10;
        const dataRowHeight = 15;

        const headers = [...this.T.historyHeaders];
        const colWidths = [18, 22, 70, 30, 20, 20];
        let xPos = 15;

        // Draw header row
        headers.forEach((header, i) => {
            this.pdf.setFillColor(41, 82, 163);
            this.pdf.setDrawColor(0, 0, 0);
            this.pdf.setLineWidth(0.5);
            this.pdf.rect(xPos, historyY, colWidths[i], headerHeight, 'FD');

            this.pdf.setTextColor(255, 255, 255);
            this.pdf.setFontSize(7);
            this.pdf.setFont('helvetica', 'bold');

            const maxHeaderWidth = colWidths[i] - 3;
            const headerLines = this.pdf.splitTextToSize(header, maxHeaderWidth);
            const startY = historyY + (headerHeight / 2) - ((headerLines.length - 1) * 1.5);

            headerLines.forEach((line, lineIndex) => {
                this.pdf.text(line, xPos + 1.5, startY + (lineIndex * 3));
            });

            xPos += colWidths[i];
        });

        // Add data row
        xPos = 15;
        const versionData = [
            this.metadata.version || '1.0',
            new Date().toLocaleDateString(this.T.locale),
            this.T.initialEntry,
            '',
            '',
            ''
        ];

        versionData.forEach((data, i) => {
            this.pdf.setFillColor(245, 245, 245);
            this.pdf.setDrawColor(0, 0, 0);
            this.pdf.setLineWidth(0.5);
            this.pdf.rect(xPos, historyY + headerHeight, colWidths[i], dataRowHeight, 'FD');

            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFontSize(7);
            this.pdf.setFont('helvetica', 'normal');

            if (data) {
                const maxColWidth = colWidths[i] - 3;
                const lines = this.pdf.splitTextToSize(data, maxColWidth);
                const maxLines = Math.floor((dataRowHeight - 2) / 3);
                const displayLines = lines.slice(0, maxLines);

                if (lines.length > maxLines && displayLines.length > 0) {
                    let truncatedLine = displayLines[displayLines.length - 1];
                    const ellipsisWidth = this.pdf.getTextWidth('...');
                    const availableWidth = maxColWidth - ellipsisWidth;

                    while (this.pdf.getTextWidth(truncatedLine) > availableWidth && truncatedLine.length > 0) {
                        truncatedLine = truncatedLine.slice(0, -1);
                    }
                    displayLines[displayLines.length - 1] = truncatedLine + '...';
                }

                const startY = historyY + headerHeight + (dataRowHeight / 2) - ((displayLines.length - 1) * 1.5);
                displayLines.forEach((line, lineIndex) => {
                    this.pdf.text(line, xPos + 1.5, startY + (lineIndex * 3));
                });
            }
            xPos += colWidths[i];
        });

        // Footer
        const footerY = pageHeight - 20;
        this.pdf.setFontSize(8);
        this.pdf.setTextColor(107, 114, 128);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.footerMethodo, 105, footerY, { align: 'center' });
        this.pdf.text(this.T.footerConfidential, 105, footerY + 8, { align: 'center' });
    }

    /**
     * Start new content page with clean background
     */
    startNewPage() {
        this.pdf.addPage();
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();

        // White background
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(0, 0, pageWidth, pageHeight, 'F');
    }

    /**
     * Add semi-transparent diagonal watermark
     * @param {string} text - Watermark text
     */
    addWatermark(text = this.T.watermarkDefault) {
        // Save current state
        this.pdf.saveGraphicsState();

        // Set opacity for watermark
        this.pdf.setGState(new this.pdf.GState({ opacity: 0.08 }));

        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();
        const centerX = pageWidth / 2;
        const centerY = pageHeight / 2;

        // Create diagonal watermarks
        const watermarkInstances = [
            {
                x: centerX - 40,
                y: centerY - 60,
                size: 32,
                angle: -45
            },
            {
                x: centerX + 40,
                y: centerY + 60,
                size: 32,
                angle: -45
            }
        ];

        watermarkInstances.forEach(instance => {
            this.pdf.saveGraphicsState();

            this.pdf.setFontSize(instance.size);
            this.pdf.setTextColor(140, 140, 140);
            this.pdf.setFont('helvetica', 'normal');

            this.pdf.text(text, instance.x, instance.y, {
                align: 'center',
                angle: instance.angle
            });

            this.pdf.restoreGraphicsState();
        });

        this.pdf.restoreGraphicsState();
    }

    /**
     * Add professional page headers and footers to all pages
     */
    addPageNumbers() {
        const pageCount = this.pdf.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            this.pdf.setPage(i);

            // Add watermark to ALL pages
            this.addWatermark();

            // Skip header/footer on cover page
            if (i === 1) continue;

            const pageWidth = this.pdf.internal.pageSize.getWidth();
            const pageHeight = this.pdf.internal.pageSize.getHeight();

            // === PAGE HEADER ===
            const headerY = 15;

            // Header line
            this.pdf.setDrawColor(229, 231, 235);
            this.pdf.setLineWidth(0.5);
            this.pdf.line(20, headerY + 5, pageWidth - 20, headerY + 5);

            // Document title on left
            this.pdf.setFontSize(8);
            this.pdf.setTextColor(107, 114, 128);
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text(this.T.pageHeader, 20, headerY);

            // Section name on right
            let sectionName = '';
            if (i === 2) {
                sectionName = this.T.sectionOverview;
            } else if (i >= 3) {
                sectionName = this.T.sectionDetails;
            }

            if (sectionName) {
                this.pdf.text(sectionName, pageWidth - 20, headerY, { align: 'right' });
            }

            // === PAGE FOOTER ===
            const footerY = pageHeight - 10;

            // Footer line
            this.pdf.setDrawColor(229, 231, 235);
            this.pdf.setLineWidth(0.5);
            this.pdf.line(20, footerY - 5, pageWidth - 20, footerY - 5);

            // Left: Document info
            this.pdf.setFontSize(8);
            this.pdf.setTextColor(107, 114, 128);
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text(this.T.pageFooterLeft, 20, footerY);

            // Center: Confidentiality notice
            const centerText = this.T.pageFooterCenter;
            this.pdf.text(centerText, pageWidth / 2, footerY, { align: 'center' });

            // Right: Page number
            this.pdf.text(`Page ${i}`, pageWidth - 20, footerY, { align: 'right' });
        }
    }

    /**
     * Generate security framework overview section
     */
    generateOverviewSection() {
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        let currentY = 30;

        // Section title
        this.pdf.setFontSize(18);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.overviewTitle, 20, currentY);
        currentY += 15;

        // Introduction
        this.pdf.setFontSize(10);
        this.pdf.setTextColor(51, 65, 85);
        this.pdf.setFont('helvetica', 'normal');

        const introText = this.T.introText(this.metadata.rulesCount);

        const introLines = this.pdf.splitTextToSize(introText, 170);
        introLines.forEach(line => {
            this.pdf.text(line, 20, currentY);
            currentY += 6;
        });
        currentY += 15;

        // Statistics by framework
        const selectedRules = this.securityFrameworkData.selectedRules || {};
        const frameworkNamesCache = this.securityFrameworkData.frameworkNamesCache || {};
        const frameworkStats = {};
        const statusStats = {};

        Object.entries(selectedRules).forEach(([frameworkKey, rules]) => {
            if (Array.isArray(rules) && rules.length > 0) {
                const frameworkName = frameworkNamesCache[frameworkKey] || `Framework ${frameworkKey}`;
                frameworkStats[frameworkName] = rules.length;

                // Count by status
                rules.forEach(rule => {
                    const status = rule.status || 'not-applied';
                    statusStats[status] = (statusStats[status] || 0) + 1;
                });
            }
        });

        // Framework distribution
        this.pdf.setFontSize(14);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.distByFramework, 20, currentY);
        currentY += 12;

        Object.entries(frameworkStats).forEach(([frameworkName, count]) => {
            const percentage = Math.round((count / this.metadata.rulesCount) * 100);

            this.pdf.setFontSize(10);
            this.pdf.setTextColor(51, 65, 85);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text(frameworkName, 25, currentY);

            // Count and percentage
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text(this.T.ruleCountLine(count, percentage), 100, currentY);

            // Progress bar
            const barWidth = 60;
            const barHeight = 5;
            const barX = 140;
            const barY = currentY - 4;
            const fillWidth = (barWidth * percentage) / 100;

            // Background bar
            this.pdf.setFillColor(229, 231, 235);
            this.pdf.roundedRect(barX, barY, barWidth, barHeight, 1, 1, 'F');

            // Filled bar
            if (fillWidth > 0) {
                this.pdf.setFillColor(59, 130, 246); // Blue
                this.pdf.roundedRect(barX, barY, fillWidth, barHeight, 1, 1, 'F');
            }

            currentY += 10;
        });

        currentY += 10;

        // Status distribution
        this.pdf.setFontSize(14);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.distByStatus, 20, currentY);
        currentY += 12;

        Object.entries(statusStats).forEach(([status, count]) => {
            const statusLabel = this.statusLabels[status] || status;
            const statusColor = this.statusColors[status] || [100, 100, 100];
            const percentage = Math.round((count / this.metadata.rulesCount) * 100);

            // Status badge
            this.pdf.setFillColor(...statusColor);
            this.pdf.circle(25, currentY - 1.5, 2, 'F');

            this.pdf.setFontSize(10);
            this.pdf.setTextColor(51, 65, 85);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text(statusLabel, 30, currentY);

            // Count and percentage
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text(this.T.ruleCountLine(count, percentage), 100, currentY);

            // Progress bar
            const barWidth = 60;
            const barHeight = 5;
            const barX = 140;
            const barY = currentY - 4;
            const fillWidth = (barWidth * percentage) / 100;

            // Background bar
            this.pdf.setFillColor(229, 231, 235);
            this.pdf.roundedRect(barX, barY, barWidth, barHeight, 1, 1, 'F');

            // Filled bar
            if (fillWidth > 0) {
                this.pdf.setFillColor(...statusColor);
                this.pdf.roundedRect(barX, barY, fillWidth, barHeight, 1, 1, 'F');
            }

            currentY += 10;
        });
    }

    /**
     * Generate detailed rules section as separate tables per framework
     */
    generateRulesDetailsSection() {
        // Add new landscape page for the table
        this.pdf.addPage('a4', 'l');
        
        const selectedRules = this.securityFrameworkData.selectedRules || {};
        const frameworkNamesCache = this.securityFrameworkData.frameworkNamesCache || {};
        
        // Section title with vertical spacing
        this.pdf.setFontSize(14);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.rulesSectionTitle, 15, 25);
        
        let currentY = 35;
        let ruleIndex = 0;
        
        Object.entries(selectedRules).forEach(([frameworkKey, rules]) => {
            if (!Array.isArray(rules) || rules.length === 0) return;
            
            const frameworkName = frameworkNamesCache[frameworkKey] || `Framework ${frameworkKey}`;
            
            // Build table data for this framework
            const frameworkTableData = rules.map(rule => {
                ruleIndex++;

                const statusLabel = this.statusLabels[rule.status] || rule.status || '-';

                const descText = rule.description || '-';

                const justText = rule.justification || '-';

                const ruleGapComments = this.securityFrameworkData.ruleGapComments || {};
                const ruleDreadedEvents = this.securityFrameworkData.ruleDreadedEvents || {};
                const linkedDeIds = (ruleDreadedEvents[rule.id] || []).filter(id => id !== '__v');
                const deNames = linkedDeIds.map(deId => {
                    const de = this.dreadedEventsData.find(d => String(d.id) === String(deId));
                    if (!de) return null;
                    const prefix = de.businessValue === '__global__'
                        ? this.T.nonIntentionalRisk
                        : this.T.fearedEvent;
                    return `${prefix} : ${de.name}`;
                }).filter(Boolean);
                const gapText = ruleGapComments[rule.id] || '';
                const formattedDeNames = deNames.map(name => `- ${name}`);
                const gapCell = gapText
                    ? this.T.commentPrefix + gapText + (formattedDeNames.length > 0 ? '\n\n' + formattedDeNames.join('\n\n') : '')
                    : (formattedDeNames.length > 0 ? formattedDeNames.join('\n\n') : '-');

                return [
                    ruleIndex.toString(),
                    rule.name || this.T.unnamedRule,
                    descText,
                    statusLabel,
                    gapCell,
                    justText
                ];
            });
            
            // Add framework header
            this.pdf.setFontSize(11);
            this.pdf.setTextColor(30, 64, 175);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text(frameworkName, 15, currentY);
            currentY += 8;
            
            // Add table for this framework
            this.pdf.autoTable({
                startY: currentY,
                head: [this.T.tableHead],
                body: frameworkTableData,
                theme: 'grid',
                margin: { top: 30, bottom: 20, left: 5, right: 5 },
                styles: {
                    fontSize: 8,
                    cellPadding: 3,
                    lineColor: [200, 200, 200],
                    lineWidth: 0.1,
                    overflow: 'linebreak'
                },
                headStyles: {
                    fillColor: [41, 82, 163],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    fontSize: 8
                },
                columnStyles: {
                    0: { cellWidth: 12, halign: 'center' },
                    1: { cellWidth: 45, fontStyle: 'bold' },
                    2: { cellWidth: 100 },
                    3: { cellWidth: 25, halign: 'center' },
                    4: { cellWidth: 55 },
                    5: { cellWidth: 40 }
                }
            });
            
            currentY = this.pdf.lastAutoTable.finalY + 12;
        });
    }

    /**
     * Generate professional security framework PDF report
     * @returns {Promise<Blob>} PDF blob
     */
    async generateSecurityFrameworkReport() {
        try {
            console.log('[SecurityFrameworkPdfGenerator] Starting PDF generation');

            // Page 1: Cover Page
            this.generateCoverPage();

            // Page 2: Overview
            this.startNewPage();
            this.generateOverviewSection();

            // Page 3+: Rule Details (landscape)
            this.generateRulesDetailsSection();

            // Add watermarks, headers and footers to all pages
            this.addPageNumbers();

            console.log('[SecurityFrameworkPdfGenerator] PDF generation completed');
            return this.getBlob();

        } catch (error) {
            console.error('[SecurityFrameworkPdfGenerator] Error generating PDF:', error);
            throw error;
        }
    }

    /**
     * Get PDF as blob
     * @returns {Blob} PDF blob
     */
    getBlob() {
        return this.pdf.output('blob');
    }

    /**
     * Download PDF
     * @param {string} filename - PDF filename
     */
    download(filename = this.T.defaultSaveName) {
        this.pdf.save(filename);
    }
}

export default SecurityFrameworkPdfGenerator;
